import React from 'react';
import { TextInput, TranslatableInputs } from 'react-admin';

import locales from '../../../services/locales';

const PictureTranslatableInputs = (props) => {
	const source = props.source ? `${props.source}.translations` : 'translations';

	return (
		<TranslatableInputs locales={locales} {...props} groupKey={props.source}>
			<TextInput label="Title" source={`${source}.title`} fullWidth />
			<TextInput label="Description" source={`${source}.description`} fullWidth />
		</TranslatableInputs>
	);
};

export default PictureTranslatableInputs;